import { useEffect } from "react";
import { useAuth, useUser } from "@clerk/react";
import { usePostHog } from "@posthog/react";

export function PostHogIdentity() {
  const posthog = usePostHog();
  const { isLoaded: isAuthLoaded, userId } = useAuth();
  const { isLoaded: isUserLoaded, user } = useUser();

  useEffect(() => {
    if (!isAuthLoaded || !isUserLoaded) {
      return;
    }

    if (!userId || !user) {
      posthog.reset();
      return;
    }

    posthog.identify(userId, {
      auth_provider: "clerk",
    });
  }, [isAuthLoaded, isUserLoaded, posthog, user, userId]);

  return null;
}
